import * as React from 'react';
import { ArrowLeft, Mail, Phone, UserRound } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Field, Input } from '@/components/ui/input';
import { authApi } from '@/lib/api/endpoints';
import { userMessage } from '@/lib/api/errors';
import { AuthLayout } from './AuthLayout';

export function PasswordResetPage() {
  const [full_name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [sent, setSent] = React.useState(false);
  async function submit(e: React.FormEvent) {
    e.preventDefault(); setBusy(true);
    try {
      await authApi.requestPasswordReset({ full_name: full_name.trim(), email: email.trim().toLowerCase(), phone: phone.replace(/[\s-]/g, '') });
      setSent(true);
      toast.success('Request sent to the administrator.');
    } catch (err) { toast.error(userMessage(err, 'Could not send request.')); }
    finally { setBusy(false); }
  }
  return <AuthLayout>
    <Link to="/login" className="mb-5 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground"><ArrowLeft className="size-4" /> Back to sign in</Link>
    <h1 className="text-3xl font-extrabold tracking-tight">Request a password reset</h1>
    <p className="mt-2 text-muted-foreground">Send the name, email, and phone number on your account. An administrator will verify them.</p>
    {sent ? <div className="mt-7 rounded-xl border bg-card p-4 text-sm">Your request is in the administrator queue. After an administrator verifies your details and resets the account, sign in with the temporary password ?password? and change it right away.</div> :
    <form onSubmit={submit} className="mt-7 space-y-4">
      <Field label="Full name" htmlFor="reset-name"><Input id="reset-name" icon={<UserRound />} autoComplete="name" required minLength={2} value={full_name} onChange={e => setName(e.target.value)} /></Field>
      <Field label="Email" htmlFor="reset-email"><Input id="reset-email" type="email" icon={<Mail />} autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} /></Field>
      <Field label="Phone" htmlFor="reset-phone"><Input id="reset-phone" type="tel" icon={<Phone />} autoComplete="tel" required value={phone} onChange={e => setPhone(e.target.value)} /></Field>
      <Button type="submit" className="w-full" loading={busy}>Send reset request</Button>
    </form>}
  </AuthLayout>;
}
